import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c(VDivider,{staticClass:"mb-4"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }